import { ORDER_TYPES, STAFF_TYPE_IDS } from '@/constants/orderTypes'
import { PAYMENT_TYPES } from '@/constants/paymentTypes'

export default {
    getAllOrders: state => state.orders,
    getTotalOrders: state => state.totalOrders,
    getStatusesForFilter: state => {
        return state.statuses.map(e => ({
            value: e.id,
            text: e.name,
            count: e.count,
            color: e.color,
        }))
    },
    getStatusesForChange: state => {
        return state.statusesForChange.map(e => ({
            value: e.id,
            text: e.name,
        }))
    },
    getOrderChanges: state => state.changesOrder,
    getPrintedOrders: state => state.printedOrders,
    getUnprintedInvoices: state => state.unprintedInvoices,
    getPrintedInvoicesCount: state => state.printedInvoicesCount,
    getMultiPrintStatus: state => state.isMultiPrintInProgress,
    hasOrderChanges: state =>
        state.changesOrder && state.changesOrder.length > 0,
    getMenu: state => state.menu,
    getMenuTotal: state => state.menuTotal,
    getNotifications: state => state.notifications,
    getDivisionName: state => {
        return state.previewOrder.division_id
            ? state.divisions.find(e => e.id === state.previewOrder.division_id)
                  ?.name || ''
            : ''
    },
    getNotificationOrdrers: state => {
        if (!state.notifications) return {}
        const orders = {}
        state.notifications.forEach(notification => {
            if (!orders[notification.order_id]) {
                orders[notification.order_id] = {
                    notifications: [],
                    lastNtf: {},
                }
            }
            orders[notification.order_id].notifications.push(notification)
            ;[orders[notification.order_id].lastNtf] = orders[
                notification.order_id
            ].notifications.toSorted((a, b) => {
                return new Date(b.created_date) - new Date(a.created_date)
            })
        })

        const sortable = Object.fromEntries(
            Object.entries(orders).sort(([, a], [, b]) => {
                return (
                    new Date(b.lastNtf.created_date) -
                    new Date(a.lastNtf.created_date)
                )
            })
        )

        return sortable
    },
    getNotificationsCount: state => {
        return state.notifications?.length || 0
    },
    getNotificationsForOrder: state => idOrder => {
        return state.notifications?.filter(e => e.order_id === idOrder) || []
    },

    getIdEventsByOrderId: state => idOrder => {
        return (
            state.notifications
                ?.filter(e => e.order_id === idOrder)
                .map(e => e.id) || []
        )
    },
    getDiscount: state =>
        state.previewOrder.promos?.find(
            el => el.type === 'eds_discount' && !el.deleted_date
        ),
    getPromo: state =>
        state.previewOrder.promos?.find(
            el => el.type === 'promo' && !el.deleted_date
        ),
    getChangeFrom: state =>
        state.previewOrder.payments[0].payment_type_id === PAYMENT_TYPES.CASH
            ? state.previewOrder.payments[0].change_from || 0
            : 0,
    getFinalPrice: state => {
        if (
            !state.previewOrder?.payments ||
            !state.previewOrder?.payments.length
        )
            return 0
        const { payments } = state.previewOrder
        return payments.reduce((acc, el) => acc + el.final_price, 0)
    },
    isSelfOrderType: state =>
        state.previewOrder.order_type?.id === ORDER_TYPES.SELF,
    isPreOrderType: state =>
        state.previewOrder.order_type?.id === ORDER_TYPES.PREORDER,
    isStaffOrderType: state =>
        STAFF_TYPE_IDS.includes(state.previewOrder.order_type?.id),
    getIsWaitingStartCooking: state =>
        state.previewOrder?.status?.id === 'waiting_start_cooking',
    orderType: state => state.previewOrder?.order_type?.id,
    getIsFirstPaymentUnderContract: state =>
        state.previewOrder?.payments[0].payment_type_id ===
        PAYMENT_TYPES.PAYMENT_UNDER_CONTRACT,
}
